import initialState from './initialState'

import {
  BEGIN_ADDING_DIET_PRODUCT_TO_CART,
  ADD_DIET_PRODUCT_TO_CART,
  FINISH_ADDING_DIET_PRODUCT_TO_CART,
} from '../actions/actionTypes'

export default function dietReducer(state = initialState.diet, action) {
  switch (action.type) {
    case BEGIN_ADDING_DIET_PRODUCT_TO_CART: {
      return { ...state, isLoading: true }
    }

    case ADD_DIET_PRODUCT_TO_CART: {
      if (!state.hasOwnProperty('diet')) {
        return {
          ...state,
          diet: {
            cart: [action.item],
          },
        }
      } else {
        if (
          state.diet.cart.some((e) => e.ingredient == action.item.ingredient)
        ) {
          return state
        } else {
          return {
            ...state,
            diet: {
              ...state.diet,
              cart: [...state.diet.cart, action.item],
            },
          }
        }
      }
    }

    case FINISH_ADDING_DIET_PRODUCT_TO_CART: {
      return { ...state, isLoading: false }
    }

    default:
      return state
  }
}
